import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import PrimitiveDateInput from '@/components/form/_primitives/date/PrimitiveDateInput.tsx';
import { PrimitiveInputSize } from '@/components/form/_primitives/PrimitiveInput.tsx';

type DateInputProps<TFormValues extends FieldValues> = {
  label?: string;
  dateFieldName: FieldPath<TFormValues>;
  control: Control<TFormValues>;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  onChange?: (date: Date | undefined) => void;
  defaultMonth?: Date;
  /** 30 px zamiast 34 px — wyłącznie dla kontrolek paska narzędzi tabeli. */
  inputSize?: PrimitiveInputSize;
};

export function DateInput<TFormValues extends FieldValues>({
  label,
  dateFieldName,
  control,
  required = false,
  disabled = false,
  error,
  onChange,
  defaultMonth,
  inputSize,
}: DateInputProps<TFormValues>) {
  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      {label && (
        <InputLabel label={label} required={required} disabled={disabled} />
      )}
      <Controller
        control={control}
        name={dateFieldName}
        rules={{ required }}
        render={({ field, fieldState }) => {
          const errorMessage = error ?? fieldState.error?.message;
          const dateValue = field.value ? new Date(field.value) : undefined;
          return (
            <>
              <PrimitiveDateInput
                id={dateFieldName}
                name={dateFieldName}
                value={dateValue}
                disabled={disabled}
                error={errorMessage}
                inputSize={inputSize}
                drawerTitle={label}
                calendarOptions={{ defaultMonth }}
                onChange={(date) => {
                  field.onChange(date);
                  onChange?.(date);
                }}
                onBlur={field.onBlur}
              />
              <InputError error={errorMessage} />
            </>
          );
        }}
      />
    </div>
  );
}
